const state = {
  // 人员权限
  point_admin_power: '',
  // 积分列表---（未审批  已审批  已拒绝）
  point_list_status: '0',
  // 审批页面
  point_to_apply: '0'
}

const mutations = {
  POINT_ADMIN_POWER: (state, point_admin_power) => {
    state.point_admin_power = point_admin_power
  },
  POINT_LIST_STATUS: (state, point_list_status) => {
    state.point_list_status = point_list_status
  },
  POINT_TO_APPLY: (state, point_to_apply) => {
    state.point_to_apply = point_to_apply
  }
}

const actions = {
  point({ commit }, point_admin_power) {
    commit('POINT_ADMIN_POWER', point_admin_power)
  },
  point_list({ commit }, point_list_status) {
    commit('POINT_LIST_STATUS', point_list_status)
  },
  point_to({ commit }, point_to_apply) {
    commit('POINT_TO_APPLY', point_to_apply)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
